<template>
    <div class="space-y-32">
        <div v-if="recoveryCodes" >
            <p class="text-body-sm mb-32" v-html="$t('two_factor_config.recovery_1')"></p>
            <p class="text-body-sm mb-32" v-html="$t('two_factor_config.recovery_2')"></p>
            <p class="font-semibold text-body-sm mb-8"  v-html="$t('two_factor_config.recovery_title')"></p>

            <copy-to-clipboard :copy-value="recoveryCodes.join('\n')">
                <ul class="font-mono font-semibold">
                    <li v-for="code in recoveryCodes">
                        {{ code }}
                    </li>
                </ul>
            </copy-to-clipboard>
        </div>

        <simple-button
            class="w-full"
            display="secondary"
            look="primary"
            @click="continueToApp"
        >
            {{ $t('two_factor_config.continue') }}
        </simple-button>
    </div>
</template>

<script>
import { copyToClipboard } from '../../../shared/helpers';
import SvgIcon from './SvgIcon.vue';
import SimpleButton from './SimpleButton.vue';
import CopyToClipboard from "./CopyToClipboard.vue";

export default {
    components: {
        CopyToClipboard,
        'svg-icon': SvgIcon,
        'simple-button': SimpleButton,
    },
    props: {
        recoveryCodes: Array,
        largerText: Boolean,
    },
    methods: {
        copyToClipboard,
        continueToApp() {
            window.location.href = '/';
        }
    }
}
</script>
